function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

var iconsInViewPort = []

var msdwSvgAnchor = document.getElementById("msdw-svg-anchor")

var svg = msdwSvgAnchor.getElementsByTagName('svg')

function animate() {
  iconsInViewPort = []

  for (var i = 0; i < svg.length; i++) {
    if (isElementInViewport(svg[i])) {
      var path = svg[i].querySelectorAll('.path'),
        path1 = svg[i].querySelectorAll('.path1'),
        path2 = svg[i].querySelectorAll('.path2'),
        path3 = svg[i].querySelectorAll('.path3'),
        path4 = svg[i].querySelectorAll('.path4')
      if (!svg[i].animated) {
        svg[i].animated = true
        anime({
          targets: path,
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 300,
          opacity: 1,
          delay: function (el, i) {
            return i * 200
          }
        });
        anime({
          targets: path1,
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 300,
          opacity: 1,
          delay: function (el, i) {
            return i * 200
          }
        });
        anime({
          targets: path2,
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 200,
          opacity: 1,
          delay: function (el, i) {
            return i * 400
          }
        });
        anime({
          targets: path3,
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 300,
          opacity: 1,
          delay: function (el, i) {
            return i * 300
          }
        });
        anime({
          targets: path4,
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 300,
          opacity: 1,
          delay: function (el, i) {
            return i * 300
          }
        });
      }
    }
  }
}

document.addEventListener('scroll', animate)

window.onload = function () {
  animate()
}


// smooth scroll for arrow down
document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});


// // poster frame click event
// $(document).on('click','.msdw-video-poster',function(ev) {
//   ev.preventDefault();
//   var $poster = $(this);
//   var $wrapper = $poster.closest('.msdw-video-wrapper');
//   videoPlay($wrapper);

//   console.log('clicked')
// });

// // play the targeted video (and hide the poster frame)
// function videoPlay($wrapper) {
//   var $iframe = $wrapper.find('.js-videoIframe');
//   var src = $iframe.data('src');
//   // hide poster
//   $wrapper.addClass('videoWrapperActive');
//   console.log($wrapper)
//   // add iframe src in, starting the video
//   $iframe.attr('src',src);
// }

$(document).on('click', '.msdw-js-videoPoster', function (ev) {
  ev.preventDefault();
  var $poster = $(this);
  var $wrapper = $poster.closest('.msdw-js-videoWrapper');
  videoPlay($wrapper);
});

// play the targeted video (and hide the poster frame)
function videoPlay($wrapper) {
  var $iframe = $wrapper.find('.msdw-js-videoIframe');
  var src = $iframe.data('src');
  // hide poster
  $wrapper.addClass('msdw-videoWrapperActive');
  // add iframe src in, starting the video
  $iframe.attr('src', src);
}



const pickers = document.querySelectorAll('.msdw-picker-trigger');

pickers && pickers.forEach(picker => {
  picker.addEventListener('click', () => {
    window.jwsdwMediator.publish('openPicker', 'infoPicker', {
      'content': `<div class="jws-textAlignCenter">
          <img src="${picker.dataset.icon}" alt="${picker.dataset.alt}">
        </div>
        <h3 class="jws-headline5 jws-textAlignCenter jws-margin-top-5">
          ${picker.dataset.hl}
        </h3>
        <div class="jws-copy1">
          <div class="msdw-${picker.dataset.color}-divider jws-margin-top-bottom-5"></div>
          <strong>${picker.dataset.sl}</strong><br><br>
          ${picker.dataset.content}
        </div>`
    });
  }, false);
});
